export const DAYS = 'days';
export const WEEKS = 'weeks';
export const MONTHS = 'months';

export const TIME_UNITS = [
    DAYS,
    WEEKS,
    MONTHS,
];



// WEBPACK FOOTER //
// ./src/sources/constants/timeUnits.js